export const formatTravelTime = (time: string, format?: string) => {
  const hh = time.substr(0, 2).replace(/^0/, '');
  const mm = time.substr(2, 2);
  if (format === 'm') return mm;
  if (format === 'HH') return hh;

  return `${hh}h ${mm}m`;
};

export const formatFlightNumber = (flightNumber: string): string => {
  return flightNumber.replace(/\/.*$/, '');
};
